/** Highlighted option in this picker's popup chain, including an open price flyout. */
export const pickerHasHighlightedOption = (picker: HTMLElement) => {
    const input = picker.querySelector("input[role='combobox']");
    const listId = input?.getAttribute("aria-controls")?.split(" ")[0];
    const list = listId ? document.getElementById(listId) : null;
    const chainId = list
        ?.closest("[data-picker-chain]")
        ?.getAttribute("data-picker-chain");
    if (!chainId) {
        return false;
    }
    return Array.from(
        document.querySelectorAll(
            `[data-picker-chain="${chainId}"] [data-highlighted]`,
        ),
    ).some(
        (option) =>
            option.getAttribute("role") === "option" &&
            option.closest("[hidden]") === null,
    );
};
